"use strict";

import { PhoneNumber } from "@/Common/Api/Contacts/Dto/PhoneNumber";
import { IClickToDialProps } from "@/Common/Components/CallCenter/ClickToDial.types";
import { ClickToDialView } from "@/Common/Components/CallCenter/ClickToDialView";
import { PhoneType } from "@/Common/Models/Contacts/Enums/PhoneType";

interface IClickToDialViewPhoneNumberProps extends IClickToDialProps {
    phoneNumber: PhoneNumber,
    showPhoneType?: boolean
}

function ClickToDialViewPhoneNumber(props: Readonly<IClickToDialViewPhoneNumberProps>): JSX.Element {
    const { phoneNumber, showPhoneType, ...rest } = props;
    const formattedNumber: string = PhoneNumber.stringFormattedPhone(phoneNumber, true);
    const isDialable: boolean = phoneNumber.PhoneTypeLookupId == cacheStore.getLookupByPhoneType(PhoneType.Phone)?.LookupID ||
        phoneNumber.PhoneTypeLookupId == cacheStore.getLookupByPhoneType(PhoneType.Mobile)?.LookupID;

    let phoneType: string = "";
    if (showPhoneType && phoneNumber.PhoneTypeLookupId) {
        phoneType = ` (${cacheStore.GetLocalizedValueByLookupId(phoneNumber.ContactPointTypeLookupId)} - ${cacheStore.GetLocalizedValueByLookupId(phoneNumber.PhoneTypeLookupId)})`;
    }
    if (isDialable) {
        return <><ClickToDialView {...rest} formattedPhoneNumber={formattedNumber} />{phoneType}</>;
    }
    else {
        return <>{formattedNumber}{phoneType}</>;
    }
}

export { ClickToDialViewPhoneNumber };
